import api from "../api/axios";
import ENDPOINTS from "../api/endpoints";

export const sendContactMessage = async (payload) => {
  const response = await api.post(ENDPOINTS.CONTACT.SEND, payload);
  return response.data;
};

const contactService = {
  sendContactMessage,
};

export default contactService;